


// 自定义校验
export function genericAttributeValidate (item, formData) { 
    return (rule, value, cb) => {
        let newValue = value || formData[item.attributeId];
        if(rule.required){
            if(!newValue || (Array.isArray(newValue) && !newValue.length)){
                return cb(new Error(`请添加${item.attributeName}`))
            }
        }
        /*
        ** attributeMode: 0 手工输入 1 下拉多选,2 下拉单选,3 下拉单选,4 下拉多选+手工输入
        */
        let totalRatio = 0;
        if(item.attributeMode === 4){ 
            newValue?.forEach(v => {
                if(rule.required && (!v.value || !v.key)){
                    return cb(new Error(`不能为空`))
                }
                if(item.attributeType === 3){
                    totalRatio += Number(v.value)
                }
            })
        }
        // console.log('v:',newValue,formData[item.attributeId])
        // console.log('attributeName:',item.attributeName,'attributeType:',item.attributeType,'attributeMode:',item.attributeMode,'totalRatio:',totalRatio)
        // 成分属性需要满足100%
        if((item.attributeType === 3 && item.attributeMode === 4) && totalRatio !== 100){ 
            if(newValue && newValue.length > 0){
                return cb(new Error(`成分比例需要满足100%`))
            }
        }
        cb()
    }
}
// 为空校验
export function requiredValidate () { 
    return (rule, value, callback) => {
        if (!value) {
            callback(new Error(''));
        } else {
            callback(); 
        }
    }
}